import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image1 from "../../../../assets/images/Blog40/image1 China deal incomplete_.png";
import image2 from "../../../../assets/images/Blog40/image19 Trump 1.0 2.0.png";
import image3 from "../../../../assets/images/Blog40/image4 WTI needs to break 65-8 zone.png";
import image15 from "../../../../assets/images/Blog40/image6 gold facing big support test.png";
import image9 from "../../../../assets/images/Blog40/image3 Central Banks decisions.png";
import image21 from "../../../../assets/images/Blog40/image37 US10Y v Crude Oil.png";
import image22 from "../../../../assets/images/Blog40/image18 NAS100 buy and buy the gap fill if it happens.png";
import image20 from "../../../../assets/images/Blog40/image20 VIX is back risk on.png";
import image23 from "../../../../assets/images/Blog40/image45 SPXew.png";
import image24 from "../../../../assets/images/Blog40/image22 GS Prime Book suggest Mag7 well owned going in to results.png";
import image8 from "../../../../assets/images/Blog40/image46 Miran sees his shelter print.png";
import image33 from "../../../../assets/images/Blog40/image13N.png";
import image35 from "../../../../assets/images/Blog40/image31 gold inflows relative.png";
import image39 from "../../../../assets/images/Blog40/image25 BTC bottomed or 98k flush_.png";
import image41 from "../../../../assets/images/Blog40/image4 WTI needs to break 65-8 zone.png";
import image44 from "../../../../assets/images/Blog40/image50 week ahead.png";
import image56 from "../../../../assets/images/Blog40/image6 gold facing big support test.png";
import image61 from "../../../../assets/images/Blog40/image20 VIX is back risk on.png";

const Blog40 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – October 27th, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p
          className="highlightedText "
          style={{fontStyle: "italic"}}
        >
          Melt-Up Momentum, Fed’s Balancing Act, and the 1999 Echo
        </p>
        <p>
          Markets are pushing into November with renewed optimism. The long-discussed “melt-up” is taking shape as global policymakers pivot dovish, earnings hold up, and U.S.–China relations deliver
          an unexpected tailwind. Traders are split between chasing the rally or bracing for the reversal — and history, from 1999 to 2000, reminds us how thin that line can be.
        </p>

        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Melt-Up Mechanics and China’s Catalyst</p>
              <p>
                The week opened with a strong risk-on gap after Treasury Secretary <span className="highlightedText">Scott Bessent</span> confirmed a{" "}
                <span className="highlightedText">framework agreement with China,</span> removing Trump’s 100% tariff threat and delaying Beijing’s rare-earth licensing regime. Asian equities climbed
                +1%, while U.S. indices followed suit — shipping, industrials, and commodity-linked plays led early gains.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt="systemic lending risk in US"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>

                <div className="relatedImg">
                  <img
                    src={image2}
                    alt="fin stocks hit on Thursday"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                The rally also lifted Asian currencies like the <span className="highlightedText">Won, Aussie, and Kiwi,</span> reflecting renewed confidence in China-proxy trades. Trump called it a
                “successful transaction,” and markets took it as a green light for the <span className="highlightedText">risk-on rotation</span> even as semiconductors and Taiwan exposure remained
                conspicuously absent from the move.
              </p>
              <p>
                Trump’s capex policy — allowing 100% expensing in year one — continues to turbocharge tech and AI investment. While the benefits are front-loaded, the spending surge has become a
                self-reinforcing profit machine for hyperscalers and infrastructure players.
              </p>
              <p>
                Meanwhile, Miran at the Fed is hammering the same message he has pushed for months <span className="highlightedText">"shelter inflation is overstated.”</span> With Owner’s Equivalent
                Rent posting its lowest reading since 2021, Miran argues CPI could soon show 0% or even negative shelter prints, giving the Fed ample justification for a deeper cut.
              </p>
              <p>
                Oil remains a geopolitical hinge point. Trump’s sanctions on Russia tightened supply, while China’s demand uptick added fuel to the move. Still,{" "}
                <span className="highlightedText">WTI’s 65–68 </span> range remains the zone to watch for confirmation of a longer-term recovery.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image3}
                    alt="HY not worried"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image3)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Gold, by contrast, is battling fading momentum. The <span className="highlightedText">$4,000 support</span> has so far held, but a break could open{" "}
                <span className="highlightedText">3,800–3,550.</span> Traders remain split between seeing this as a healthy consolidation or the prelude to a deeper flush.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image15}
                    alt="Friday flows into weakness"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image15)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: The Central Bank Cluster</p>
              <p>
                This week brings a policy overload <span className="highlightedText">Fed, BoC, ECB, and BoJ</span> all meet within 72 hours. The consensus calls for the{" "}
                <span className="highlightedText">BoC to cut 25bps</span> first, followed by the <span className="highlightedText">Fed’s likely 25bps</span> move. Yet Miran’s lobbying for{" "}
                <span className="highlightedText">50bps</span> has put the hawks on the defensive.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image9}
                    alt="Fed cut 99% OCT"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                The political backdrop is also shaping monetary policy. Trump’s shortlist for the next Fed Chair <span className="highlightedText"> Waller, Rieder, Hassett, Warsh, Bowman</span>{" "}
                signals continuity in dovish thinking, with Powell’s tenure expiring in May. The coming weeks will decide whether the Fed reopens the door to balance-sheet expansion after months of QT
                tapering.
              </p>
              <p>
                Elsewhere, Europe’s inflation remains stubbornly high while Japan’s pro-growth push under <span className="highlightedText">PM Takaichi</span> keeps the BoJ under pressure to normalise
                rates. Canada looks set to cut ahead of the Fed, underscoring the coordinated global easing trend.
              </p>
              <p>
                Yields below 4% across the U.S. curve have reawakened “carry-seeking” behaviour — from bonds to crypto — while volatility remains contained. The setup looks increasingly similar to the
                late-stage liquidity melt-ups of 1998–2000: policy support, improving risk appetite, and complacent volatility levels.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image21}
                    alt="Fed cut 99% OCT"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image21)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Momentum Rules the Tape</p>
              <p>
                Price action confirms what sentiment suggests — <span className="highlightedText">momentum is back in control</span>. After last week’s hesitation, indices broke out with conviction.
                The S&P 500 opened the week at new highs, leaving traders focused on the classic <span className="highlightedText">“buy the first pullback after breakout”</span> strategy.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image22}
                    alt="gamma 6600–6750"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image22)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                The <span className="highlightedText">VIX</span> sliding back to the mid-16s is a major technical tailwind. This zone triggers{" "}
                <span className="highlightedText">volatility-control flows</span> from systematic funds, which in turn adds mechanical demand for equities.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image20}
                    alt="NAS100W?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image20)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Breadth is improving as the <span className="highlightedText">SPX Equal-Weight Index (SPX-EW)</span> rises alongside the main index — a rare alignment that signals participation beyond
                the mega-caps. Yet positioning remains concentrated in the <span className="highlightedText">MAG7</span>, according to GS Prime data, leaving markets vulnerable to sharp flow reversals
                if any of these giants disappoint.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image23}
                    alt="regional banks stress"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image23)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image24}
                    alt="SMH needs a new HH"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image24)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                The Fed’s anticipated rate cut, positive gamma dynamics, and light hedging activity all point to limited near-term downside — though stretched leverage levels mean any surprise miss
                could amplify volatility.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Earnings, Inflation, and Asia’s Pulse</p>
              <p>Markets kicked off cautiously but rallied into Friday as softer data, improving China sentiment, and dovish Fed commentary aligned.</p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>U.S. CPI confirmed cooling inflation; Miran’s “shelter collapse” thesis gained traction as rent components fell sharply.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China: </span> Nominal GDP remains propped up by deflation math, while fixed asset investment continues to slide. Beijing’s policy support is
                    lagging behind economic reality.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings: </span> 34% of the S&P 500 reported; 87.4% beat estimates, the best showing in four years. EPS growth +10.4% YoY (11.2% ex-energy).
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities: </span>Gold pulled back but remains structurally bullish as yields soften. Silver mirrored the volatility before stabilising.
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image8}
                    alt="gold 10 weeks up in a row"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image8)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image33}
                    alt="GOLD W 9x up"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image33)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image35}
                    alt="silver at halfway house?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image35)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span>Midweek volatility looked like a shakeout; institutions continue accumulating below key resistance.
                  </p>
                </li>

                <div className="relatedImg">
                  <img
                    src={image39}
                    alt="BTC consolidation done?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image39)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil: </span> WTI remains range-bound; traders are watching for confirmation above 68 to sustain momentum.
                  </p>
                </li>
                <div className="relatedImg">
                  <img
                    src={image41}
                    alt="image41oil fade"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image41)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Policy and Earnings Heatmap</p>
              <p>
                Four major central bank meetings and a dense earnings calendar dominate the week ahead. Traders face a volatility cluster, with policy pivots, Q3 tech results, and global inflation
                data all set to test the “melt-up” narrative.
              </p>
              <p className="highlightedText">Monday, Oct 27</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">New Zealand:</span> Labour Day (Holiday)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China: </span>Industrial Profits YTD +0.9%
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Germany:</span> Ifo Business Climate 87.7
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S.: </span>Durable Goods Orders -2.7%
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, Oct 28</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Germany:</span> GfK Consumer Confidence (Nov) -22.3
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Italy: </span>Business & Consumer Confidence (Oct)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S.: </span>House Price Index, CB Consumer Confidence, Richmond Fed Index
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, Oct 29</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Canada:</span> BoC Rate Decision (expected -25bps)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S.:</span> Fed Rate Decision (expected -25bps or surprise -50bps)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span> Alphabet, Meta, Microsoft, eBay, Starbucks
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, Oct 30</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan: </span> BoJ Decision
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone: </span> ECB Decision
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S.:</span> Q3 GDP +3.8%, Core PCE +2.6%
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings: </span> Apple, Amazon
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Friday, Oct 31</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> Tokyo CPI, Industrial Production
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S.: </span>Employment Cost Index +0.9%, Core PCE YoY +2.9%
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image44}
                    alt="us cpi"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image44)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: The Melt-Up Has Begun — But Don’t Blink</p>
              <p>The market feels euphoric — but fragile. Liquidity, policy tailwinds, and seasonal optimism are carrying risk assets higher, yet the setup is late-cycle by every measure.</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br></br> Range-bound momentum dominating — breakouts are sticking, and program flows are supportive. Remain long biased but use tight risk management: MAG7 positioning is crowded,
                    and an earnings miss could spark rapid rotation.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span> <br></br> $4,000 remains the key line in the sand for gold. A failure risks a drop toward the $3,800–$3,550 zone; a hold
                    keeps the structural bullish case intact as yields fall.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span> <br></br> Positioning reset appears near complete. If gold flows reallocate, BTC could benefit — November is the window to watch
                    for renewed institutional flows.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span> <br></br> The Fed cut is heavily priced in; the bigger issue is what follows — if QT ends early and yields stay below 4%, liquidity
                    will continue to chase risky assets and extend this melt-up.
                  </p>
                </li>
              </ul>
              <p> As Yardeni noted, melt-ups end when logic returns. Until then, trade the flow — not the fear. Stay nimble and watch the exits.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image56}
                    alt="GOLD GVZ clues"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image56)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image61}
                    alt="VIX pop"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image61)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image39}
                    alt="VIX pop"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image39)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1wiW3AGSE5eAbNYnw73S0Nhhr3eIcnu0w1nMthx-t5XI/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog40;
